import { Navigate, Route, Routes } from 'react-router-dom';
import { Toaster } from 'sonner';
import { LoginPage } from './features/auth/login-page';
import { RegisterPage } from './features/auth/register-page';
import { OtpPage } from './features/auth/otp-page';
import { AdminLayout } from './features/admin/admin-layout';
import { AdminVerificationPage } from './features/admin/admin-verification-page';
import { AdminPermissionsPage } from './features/admin/admin-permissions-page';
import { AdminKycPage } from './features/admin/admin-kyc-page';
import { AdminTransactionsPage } from './features/admin/admin-transactions-page';
import { AdminTransactionDetailPage } from './features/admin/admin-transaction-detail-page';
import { AdminUsersPage } from './features/admin/admin-users-page';
import { AdminInvoicesPage } from './features/admin/admin-invoices-page';
import { AdminPayoutsPage } from './features/admin/admin-payouts-page';
import { AdminRefundsPage } from './features/admin/admin-refunds-page';
import { AdminServicesPage } from './features/admin/admin-services-page';
import { AdminConfigPage } from './features/admin/admin-config-page';
import { AdminReportsPage } from './features/admin/admin-reports-page';
import { AdminFeedbacksPage } from './features/admin/admin-feedbacks-page';
import { AdminAuthoritiesPage } from './features/admin/admin-authorities-page';
import { AdminAuditLogsPage } from './features/admin/admin-audit-logs-page';

import { useMe } from '@/hooks/use-me';
import { useMyPermissions } from '@/hooks/use-admin-permissions';

const SECTION_PATH_MAP: Record<string, string> = {
  TRANSACTIONS: '/transactions',
  KYC: '/kyc',
  USERS: '/users',
  INVOICES: '/invoices',
  PAYOUTS: '/payouts',
  REFUNDS: '/refunds',
  AUTHORITIES: '/authorities',
  SERVICES: '/services',
  CONFIG: '/config',
  REPORTS: '/reports',
  FEEDBACKS: '/feedbacks',
  AUDIT_LOGS: '/audit-logs',
};

function AdminIndexRedirect() {
  const { data: me } = useMe();
  const { data: myPermissions = [] } = useMyPermissions();
  if (me?.adminRole === 'SUPER_ADMIN') {
    return <Navigate to="/transactions" replace />;
  }
  const firstPermitted = myPermissions.find((p) => p.canView);
  if (firstPermitted) {
    const path = SECTION_PATH_MAP[firstPermitted.section] || '/transactions';
    return <Navigate to={path} replace />;
  }
  return <Navigate to="/transactions" replace />;
}

export function App() {
  return (
    <>
      <Toaster position="bottom-right" richColors closeButton />
      <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/otp" element={<OtpPage />} />
      <Route path="/" element={<AdminLayout />}>
        <Route index element={<AdminIndexRedirect />} />
        <Route path="transactions" element={<AdminTransactionsPage />} />
        <Route path="transactions/:id" element={<AdminTransactionDetailPage />} />
        <Route path="admin-verification" element={<AdminVerificationPage />} />
        <Route path="role-permissions" element={<AdminPermissionsPage />} />
        <Route path="kyc" element={<AdminKycPage />} />
        <Route path="users" element={<AdminUsersPage />} />
        <Route path="invoices" element={<AdminInvoicesPage />} />
        <Route path="payouts" element={<AdminPayoutsPage />} />
        <Route path="refunds" element={<AdminRefundsPage />} />
        <Route path="services" element={<AdminServicesPage />} />
        <Route path="authorities" element={<AdminAuthoritiesPage />} />
        <Route path="config" element={<AdminConfigPage />} />
        <Route path="reports" element={<AdminReportsPage />} />
        <Route path="feedbacks" element={<AdminFeedbacksPage />} />
        <Route path="audit-logs" element={<AdminAuditLogsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </>
  );
}
